import React, { useEffect, useState } from "react";
import Table from "../../../Utils/Table/Table1";

import {
  getAllUser,
  Addbalance,
  updateActivestatus,
  updateKycStatus,
  walletRecharge,
  updateOptionStatus,
  getUserDocuments
} from "../../../Services/Superadmin/Superadmin";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  CirclePlus,
  Pencil,
  CircleDollarSign,
  Eye,
  CircleMinus,
} from "lucide-react";
import { getAllClient } from "../../../Services/Superadmin/Superadmin";

import Swal from "sweetalert2";
import { fDateTime } from "../../../Utils/Date_format/datefromat";
import Loader from "../../../Utils/Loader/Loader";
import { getUserFromToken } from "../../../Utils/TokenVerify";

const Users = () => {
  const navigate = useNavigate();
  const TokenData = getUserFromToken();

  const location = useLocation();
  const path = location?.state?.path;

  useEffect(() => {
    if (path === "Totaluser") {
      setRedirectstatus("all");
    } else if (path === "activeuser") {
      setRedirectstatus("Active");
    } else if (path === "inactive") {
      setRedirectstatus("Inactive");
    } else {
      setRedirectstatus("");
    }
  }, [path]);

  const user_id = TokenData?.user_id;

  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [balance, setBalance] = useState("");
  const [modal, setModal] = useState(false);
  const [id, setID] = useState("");
  const [type, setType] = useState("");

  const [loading, setLoading] = useState(false);
  const [employeename, setEmployeename] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [getActiveInactive, setActiveInactive] = useState("all");
  const [redirectstatus, setRedirectstatus] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(search);
  const [documentModal, setDocumentModal] = useState(false);

  const [reason, setReason] = useState("");
  const [customReason, setCustomReason] = useState("");

  const [client, setClient] = useState([]);
  const [marketType, setMarketType] = useState("USD");
  const [documentData, setDocumentData] = useState([]);
  const [pageHeading, setPageHeading] = useState("All Users");
  const [totalPages, setTotalPages] = useState(1);

  // const columns = [

  //   { Header: "FullName", accessor: "FullName" },
  //   { Header: "UserName", accessor: "UserName" },
  //   { Header: "Password", accessor: "Otp" },
  //   {
  //     Header: "pin",
  //     accessor: "pin",
  //     Cell: ({ cell }) => <span>{cell.value ? cell.value : "-"}</span>,
  //   },
  //   { Header: "Email", accessor: "Email" },
  //   { Header: "Phone No", accessor: "PhoneNo" },
  //   {
  //     Header: "Plan",
  //     accessor: "plan_type",
  //     Cell: ({ cell }) => {
  //       const planLabels = {
  //         1: "Basic Plan",
  //         2: "Standard Plan",
  //         3: "Premium Plan",
  //       };

  //       return <span>{planLabels[cell.value] || "--"}</span>;
  //     },
  //   },

  //   {
  //     Header: "Employee Allotment",
  //     accessor: "employeeName",
  //     Cell: ({ cell }) => <span>{cell.value ? cell.value : "--"}</span>,
  //   },
  //   {
  //     Header: "Start Date",
  //     accessor: "Start_Date",
  //     Cell: ({ cell }) => {
  //       return fDateTime(cell.value);
  //     },
  //   },

  //   {
  //     Header: "KYC",
  //     accessor: "kyc",
  //     Cell: ({ cell }) => {
  //       return (

  //         <span
  //           className={`fw-semibold d-flex ${cell.value == 0 ? "text-danger" : "text-success"
  //             }`}
  //         >

  //           <label className="form-check form-switch">
  //             <input
  //               id={`rating_${cell.row.id}`}
  //               className="form-check-input"
  //               type="checkbox"
  //               role="switch"
  //               onChange={(event) => updateaKycstatus(event, cell.row._id)}
  //               defaultChecked={cell.value == 1}
  //             />
  //             <label
  //               htmlFor={`rating_${cell.row.id}`}
  //               className="checktoggle checkbox-bg"
  //             ></label>
  //           </label>
  //           {/* )} */}
  //           {cell.value == 0 ? "Pending" : cell.value == 1 ? "Completed" : cell.value == 2 ? "Pending" : "Rejected"}
  //         </span>

  //       );
  //     },
  //   },
  //   {
  //     Header: "Status",
  //     accessor: "ActiveStatus",
  //     Cell: ({ cell }) => (
  //       <label className="form-check form-switch">
  //         <input
  //           id={`rating_${cell.row.id}`}
  //           className="form-check-input"
  //           type="checkbox"
  //           role="switch"
  //           onChange={(event) => updateactivestatus(event, cell.row._id)}
  //           defaultChecked={cell.value == 1}
  //         />
  //         <label
  //           htmlFor={`rating_${cell.row.id}`}
  //           className="checktoggle checkbox-bg"
  //         ></label>
  //       </label>
  //     ),
  //   },

  //   client?.Edit_balance == 1 &&
  //   TokenData?.market?.includes(0) && {
  //     Header: "USD Wallet",
  //     accessor: "Balance",
  //     Cell: ({ cell }) => {
  //       const market = cell.row.market;
  //       if (!market?.includes(0)) {
  //         return "--";
  //       }

  //       return (
  //         <div
  //           style={{
  //             backgroundColor: "#E1FFED",
  //             color: "#33B469",
  //             padding: "6px 12px",
  //             display: "flex",
  //             alignItems: "center",
  //             justifyContent: "space-between",
  //             borderRadius: "10px",
  //             fontSize: "13px",
  //             fontWeight: "500",
  //             gap: "10px",
  //           }}
  //         >
  //           <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
  //             <span style={{ fontWeight: "bold" }}>
  //               {parseFloat(cell.value).toFixed(2)}
  //             </span>
  //           </div>

  //           <div style={{ display: "flex", gap: "8px" }}>
  //             <CirclePlus
  //               size={20}
  //               style={{
  //                 color: "#22c55e",
  //                 cursor: "pointer",
  //                 transition: "transform 0.2s",
  //               }}
  //               onClick={() => {
  //                 setModal(true);
  //                 setMarketType("USD");
  //                 setID(cell.row._id);
  //                 setType("CREDIT");
  //               }}
  //               onMouseOver={(e) =>
  //                 (e.currentTarget.style.transform = "scale(1.2)")
  //               }
  //               onMouseOut={(e) =>
  //                 (e.currentTarget.style.transform = "scale(1)")
  //               }
  //             />
  //             <CircleMinus
  //               size={20}
  //               style={{
  //                 color: "#ef4444",
  //                 cursor: "pointer",
  //                 transition: "transform 0.2s",
  //               }}
  //               onClick={() => {
  //                 setModal(true);
  //                 setMarketType("USD");
  //                 setID(cell.row._id);
  //                 setType("DEBIT");
  //               }}
  //               onMouseOver={(e) =>
  //                 (e.currentTarget.style.transform = "scale(1.2)")
  //               }
  //               onMouseOut={(e) =>
  //                 (e.currentTarget.style.transform = "scale(1)")
  //               }
  //             />
  //           </div>
  //         </div>
  //       );
  //     },
  //   },



  //   client?.Edit_balance == 1 && TokenData?.market?.includes(1)
  //   && {
  //     Header: "INR Wallet",
  //     accessor: "Inr_Balance",
  //     Cell: ({ cell, }) => {
  //       const market = cell.row.market;
  //       if (!market?.includes(1)) {
  //         return "--";
  //       }

  //       return (
  //         <div
  //           style={{
  //             backgroundColor: "#E1FFED",
  //             color: "#33B469",
  //             padding: "6px 12px",
  //             display: "flex",
  //             alignItems: "center",
  //             justifyContent: "space-between",
  //             borderRadius: "10px",
  //             fontSize: "13px",
  //             fontWeight: "500",
  //             gap: "10px",
  //           }}
  //         >
  //           <div
  //             style={{ display: "flex", alignItems: "center", gap: "6px" }}
  //           >
  //             <span style={{ fontWeight: "bold" }}>
  //               {parseFloat(cell.value || 0).toFixed(2)}
  //             </span>
  //           </div>

  //           <div style={{ display: "flex", gap: "8px" }}>
  //             <CirclePlus
  //               size={20}
  //               style={{
  //                 color: "#22c55e",
  //                 cursor: "pointer",
  //                 transition: "transform 0.2s",
  //               }}
  //               onClick={() => {
  //                 setModal(true);
  //                 setMarketType("INR");
  //                 setID(cell.row._id);
  //                 setType("CREDIT");
  //               }}
  //               onMouseOver={(e) =>
  //                 (e.currentTarget.style.transform = "scale(1.2)")
  //               }
  //               onMouseOut={(e) =>
  //                 (e.currentTarget.style.transform = "scale(1)")
  //               }
  //             />
  //             <CircleMinus
  //               size={20}
  //               style={{
  //                 color: "#ef4444",
  //                 cursor: "pointer",
  //                 transition: "transform 0.2s",
  //               }}
  //               onClick={() => {
  //                 setModal(true);
  //                 setMarketType("INR");
  //                 setID(cell.row._id);
  //                 setType("DEBIT");
  //               }}
  //               onMouseOver={(e) =>
  //                 (e.currentTarget.style.transform = "scale(1.2)")
  //               }
  //               onMouseOut={(e) =>
  //                 (e.currentTarget.style.transform = "scale(1)")
  //               }
  //             />
  //           </div>
  //         </div>
  //       );
  //     },
  //   },



  //   {
  //     Header: "Action",
  //     accessor: "Action",
  //     Cell: ({ cell }) => {
  //       return (
  //         <div>
  //           <Pencil
  //             width={20} height={20}
  //             className="text-primary"

  //             style={{ cursor: "pointer" }}
  //             onClick={() => updateuserpage(cell.row._id, cell)}
  //           />
  //         </div>
  //       );
  //     },
  //   },


  //   {
  //     Header: "Trade History",
  //     accessor: "Trade History",
  //     Cell: ({ cell }) => {
  //       return (
  //         <div>
  //           <Eye
  //             style={{ cursor: "pointer", color: "#1a241eff" }}
  //             onClick={() => Clienthistory(cell.row._id)}
  //           />
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     Header: "Documents",
  //     accessor: "documents",
  //     Cell: ({ cell }) => (
  //       <div>
  //         {/* CREATE A BTN TP OPEN MODAL */}
  //         <button className="btn btn-primary btn-sm" onClick={() => openDocumentModal(cell.row._id)}>
  //           View Documents
  //         </button>
  //       </div>
  //     ),
  //   },
  // ];




  const getCellValue = (row, accessor) => {
    return row?.[accessor] ?? "--";
  };


  const columns = [
    {
      Header: "S.No",
      id: "rowIndex",
      Cell: ({ row, index }) => {
        return (page - 1) * rowsPerPage + (index + 1);
      }
    },
    { Header: "FullName", accessor: "FullName" },
    { Header: "UserName", accessor: "UserName" },
    { Header: "Password", accessor: "Otp" },

    {
      Header: "Pin",
      accessor: "pin",
      Cell: ({ row }) => <span>{row.pin || "-"}</span>,
    },


    { Header: "Email", accessor: "Email" },
    { Header: "Phone No", accessor: "PhoneNo" },

    {
      Header: "Plan",
      accessor: "plan_type",
      Cell: ({ row }) => {
        const planLabels = {
          1: "Basic Plan",
          2: "Standard Plan",
          3: "Premium Plan",
        };
        return <span>{planLabels[row.plan_type] || "--"}</span>;
      },
    },


    {
      Header: "Employee Allotment",
      accessor: "employeeName",
      Cell: ({ row }) => <span>{row.employeeName || "--"}</span>,
    },

    {
      Header: "Start Date",
      accessor: "Start_Date",
      Cell: ({ row }) => {
        const date = row.Start_Date;
        if (!date) return "--";
        const d = new Date(date);
        if (isNaN(d)) return "--";
        return fDateTime(date);
      },
    },



    {
      Header: "KYC",
      accessor: "kyc",
      Cell: ({ row }) => {
        const label =
          row.kyc == 0
            ? "Pending"
            : row.kyc == 1
              ? "Completed"
              : row.kyc == 2
                ? "Pending"
                : "Rejected";

        return (
          <span
            className={`fw-semibold d-flex ${row.kyc == 0 ? "text-danger" : "text-success"
              }`}
          >
            <label className="form-check form-switch">
              <input
                id={`rating_${row?._id}`}
                className="form-check-input"
                type="checkbox"
                role="switch"
                onChange={(event) => updateaKycstatus(event, row?._id)}
                defaultChecked={row.kyc == 1}
              />
              <label
                htmlFor={`rating_${row?._id}`}
                className="checktoggle checkbox-bg"
              ></label>
            </label>
            {label}
          </span>
        );
      },
    },

    {
      Header: "Status",
      accessor: "ActiveStatus",
      Cell: ({ row }) => {
        return (
          <label className="form-check form-switch">
            <input
              id={`rating_${row?._id}`}
              className="form-check-input"
              type="checkbox"
              role="switch"
              onChange={(event) => updateactivestatus(event, row?._id)}
              defaultChecked={row.ActiveStatus == 1}
            />
            <label
              htmlFor={`rating_${row?._id}`}
              className="checktoggle checkbox-bg"
            ></label>
          </label>
        );
      },
    },

    // USD Wallet
    client?.Edit_balance == 1 &&
    TokenData?.market?.includes(0) && {
      Header: "USD Wallet",
      accessor: "Balance",
      Cell: ({ row }) => {
        const market = row?.market || row?.original?.market || [];
        if (!market.includes(0)) return "--";

        return (
          <div
            style={{
              backgroundColor: "#E1FFED",
              color: "#33B469",
              padding: "6px 12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              borderRadius: "10px",
              fontSize: "13px",
              fontWeight: "500",
              gap: "10px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <span style={{ fontWeight: "bold" }}>  {Number(row.Balance).toFixed(2)}</span>
            </div>

            <div style={{ display: "flex", gap: "8px" }}>
              <CirclePlus
                size={20}
                style={{
                  color: "#22c55e",
                  cursor: "pointer",
                  transition: "transform 0.2s",
                }}
                onClick={() => {
                  setModal(true);
                  setMarketType("USD");
                  setID(row?._id);
                  setType("CREDIT");
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = "scale(1.2)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              />
              <CircleMinus
                size={20}
                style={{
                  color: "#ef4444",
                  cursor: "pointer",
                  transition: "transform 0.2s",
                }}
                onClick={() => {
                  setModal(true);
                  setMarketType("USD");
                  setID(row?._id);
                  setType("DEBIT");
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = "scale(1.2)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              />
            </div>
          </div>
        );
      },
    },

    // INR Wallet
    client?.Edit_balance == 1 &&
    TokenData?.market?.includes(1) && {
      Header: "INR Wallet",
      accessor: "Inr_Balance",
      Cell: ({ row }) => {
        const market = row?.market || row?.original?.market || [];
        if (!market.includes(1)) return "--";
        return (
          <div
            style={{
              backgroundColor: "#E1FFED",
              color: "#33B469",
              padding: "6px 12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              borderRadius: "10px",
              fontSize: "13px",
              fontWeight: "500",
              gap: "10px",
            }}
          >
            <div
              style={{ display: "flex", alignItems: "center", gap: "6px" }}
            >
              <span style={{ fontWeight: "bold" }}>  {Number(row.Inr_Balance).toFixed(2)}</span>
            </div>

            <div style={{ display: "flex", gap: "8px" }}>
              <CirclePlus
                size={20}
                style={{
                  color: "#22c55e",
                  cursor: "pointer",
                  transition: "transform 0.2s",
                }}
                onClick={() => {
                  setModal(true);
                  setMarketType("INR");
                  setID(row?._id);
                  setType("CREDIT");
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = "scale(1.2)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              />
              <CircleMinus
                size={20}
                style={{
                  color: "#ef4444",
                  cursor: "pointer",
                  transition: "transform 0.2s",
                }}
                onClick={() => {
                  setModal(true);
                  setMarketType("INR");
                  setID(row?._id);
                  setType("DEBIT");
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = "scale(1.2)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              />
            </div>
          </div>
        );
      },
    },

    {
      Header: "Action",
      accessor: "Action",
      Cell: ({ row }) => {
        return (
          <div>
            <Pencil
              width={20}
              height={20}
              className="text-primary"
              style={{ cursor: "pointer" }}
              onClick={() => updateuserpage(row?._id, { row })}
            />
          </div>
        );
      },
    },

    {
      Header: "Trade History",
      accessor: "Trade History",
      Cell: ({ row }) => {
        return (
          <div>
            <Eye
              style={{ cursor: "pointer", color: "#1a241eff" }}
              onClick={() => Clienthistory(row?._id)}
            />
          </div>
        );
      },
    },

    {
      Header: "Documents",
      accessor: "documents",
      Cell: ({ row }) => {
        return (
          <div>
            <button
              className="btn btn-primary btn-sm"
              onClick={() => openDocumentModal(row?._id)}
            >
              View Documents
            </button>
          </div>
        );
      },
    },
  ];


  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (newPerPage) => {
    setRowsPerPage(newPerPage);
  };
  const Clienthistory = (_id) => {
    navigate(`tradehistory/${_id}`);
  };



  const updateuserpage = (_id, obj) => {
    navigate(`updateuser/${_id}`, { state: { rowData: obj.row } });
  };

  // update  balance
  const updateBalance = async () => {
    try {
      // Validate if balance is provided
      if (!balance || isNaN(balance) || parseFloat(balance) <= 0) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Please enter a valid number greater than zero for the balance.",
        });
        return;
      }

      if (!reason) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Please enter a valid Reason.",
        });
        return;
      }

      // Show confirmation popup
      const confirmation = await Swal.fire({
        title: "Confirm Update",
        text: `Are you sure you want to update the balance to ${balance}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, update it!",
        cancelButtonText: "Cancel",
      });

      // Proceed only if user confirms
      if (confirmation.isConfirmed) {
        let response;
        if (marketType == "INR") {
          response = await walletRecharge({
            id: id,
            Balance: balance,
            parent_Id: user_id,
            Type: type,
            Reason: reason === "Other" ? customReason : reason,
          });
        } else {
          response = await Addbalance({
            id: id,
            Balance: balance,
            parent_Id: user_id,
            Type: type,
            Reason: reason === "Other" ? customReason : reason,
          });
        }

        // Handle API response
        if (response.status) {
          Swal.fire({
            icon: "success",
            title: "Balance Updated",
            text:
              response.message || "The balance has been updated successfully.",
          });

          getAlluserdata();
          setModal(false);
          setBalance("");
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text:
              response.message ||
              "An error occurred while updating the balance.",
          });
        }
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: error.message || "An unexpected error occurred.",
      });
    }
  };

  // update acctive status
  const updateactivestatus = async (event, id) => {
    const user_active_status = event.target.checked ? 1 : 0;

    const result = await Swal.fire({
      title: "Do you want to save the changes?",
      showCancelButton: true,
      confirmButtonText: "Save",
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
    });

    if (result.isConfirmed) {
      try {
        const response = await updateActivestatus({ id, user_active_status });
        if (response.status) {
          Swal.fire({
            title: "Saved!",
            icon: "success",
            timer: 1000,
            timerProgressBar: true,
          });
          setTimeout(() => {
            Swal.close();
          }, 1000);
        }
      } catch (error) {
        Swal.fire(
          "Error",
          "There was an error processing your request.",
          "error"
        );
      }
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      getAlluserdata();
    }
  };

  const updateaKycstatus = async (event, id) => {
    const user_active_status = event.target.checked ? 1 : 0;

    const result = await Swal.fire({
      title: "Do you want to save the changes?",
      showCancelButton: true,
      confirmButtonText: "Save",
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
    });

    if (result.isConfirmed) {
      try {
        const response = await updateKycStatus({
          id,
          status: user_active_status,
        });
        if (response.success) {
          Swal.fire({
            title: "Saved!",
            icon: "success",
            timer: 1000,
            timerProgressBar: true,
          });

          getAlluserdata();
        }
      } catch (error) {
        Swal.fire(
          "Error",
          "There was an error processing your request.",
          "error"
        );
      }
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      getAlluserdata();
    }
  };

  const updateOptionStatusdata = async (event, id) => {
    const user_active_status = event.target.checked ? 1 : 0;

    const result = await Swal.fire({
      title: "Do you want to save the changes?",
      showCancelButton: true,
      confirmButtonText: "Save",
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
    });

    if (result.isConfirmed) {
      try {
        const response = await updateOptionStatus({
          id,
          status: user_active_status,
        });
        if (response.success) {
          Swal.fire({
            title: "Saved!",
            icon: "success",
            timer: 1000,
            timerProgressBar: true,
          });

          getAlluserdata();
        }
      } catch (error) {
        Swal.fire(
          "Error",
          "There was an error processing your request.",
          "error"
        );
      }
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      getAlluserdata();
    }
  };

  const getAlluserdata = async () => {
    setLoading(true);

    const params = {
      id: user_id,
      page,
      limit: rowsPerPage,
      search: search || "",
      ActiveStatus: redirectstatus ? redirectstatus : getActiveInactive,
    };

    try {
      const response = await getAllUser(params);
      const allUsers = response?.data || [];

      // Extract all usernames
      const userNames = allUsers.map((user) => user.UserName);


      setData(allUsers);
      setTotalPages(response?.pagination?.totalPages || 1);
      setTotalCount(response?.pagination?.totalCount || 0);

      setEmployeename(userNames);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const getallclient = async () => {
    try {
      const data = { userid: user_id };
      const response = await getAllClient(data);
      if (response.status) {
        setClient(response.data);
      }
    } catch (error) { }
  };

  useEffect(() => {
    getallclient();
  }, []);

  useEffect(() => {
    getAlluserdata();
  }, [debouncedSearch, page, rowsPerPage, getActiveInactive, redirectstatus]);

  useEffect(() => {
    setPage(1);
  }, [debouncedSearch, getActiveInactive]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [search]);


  const openDocumentModal = async (userId) => {
    let DocumentData = await getUserDocuments({ userId: userId });

    if (DocumentData.success) {
      setDocumentModal(true);
      setDocumentData(DocumentData.data);

    } else {
      Swal.fire("No Documents Found");
    }
  }
  useEffect(() => {
    if (path === "Totaluser" || path === "all") {
      setRedirectstatus("all");
      setPageHeading("All Users");
    } else if (path === "activeuser" || path === "Active") {
      setRedirectstatus("Active");
      setPageHeading("Active Users");
    } else if (path === "inactive" || path === "Inactive") {
      setRedirectstatus("Inactive");
      setPageHeading("Inactive Users");
    } else {
      setRedirectstatus("");
      setPageHeading("Users");
    }
  }, [path]);


  return (
    <>
      <div className="container-fluid mt-5">
        <div className="row">
          <div className="col-lg-12">
            <div className="card transaction-table custom-bg">
              <div className="card-header border-0 flex-wrap ">
                <div className="">
                  <h4 className="card-title text-blue-800">{pageHeading}</h4>
                </div>
                <Link
                  to="/admin/adduser"
                  className="float-end  btn btn-primary"
                >
                  Add User
                </Link>
              </div>
              <div className="card-body px-3 pb-3">

                <div className="tab-content" id="myTabContent1">
                  <div
                    className="tab-pane fade show active"
                    id="Week"
                    role="tabpanel"
                    aria-labelledby="Week-tab"
                  >
                    <div className="row mb-3 ms-2 mt-2 d-flex justify-content-between">
                      {/* Search Box */}
                      <div className="col-md-4 mb-2 ">
                        <label
                          htmlFor="searchInput"
                          className="form-label fw-bold"
                        >
                          🔍 Search
                        </label>
                        <input
                          id="searchInput"
                          type="text"
                          className="form-control"
                          placeholder="Search here..."
                          value={search}
                          onChange={(e) => setSearch(e.target.value)}
                        />
                      </div>

                      {/* Active / Inactive Filter */}
                      <div className="col-md-3 mb-2 me-2" style={{ width: "140px" }}>
                        <label htmlFor="statusSelect" className="form-label fw-bold">
                          Active / Inactive
                        </label>
                        <select
                          id="statusSelect"
                          className="form-select"
                          value={getActiveInactive}
                          onChange={(e) => setActiveInactive(e.target.value)}
                        >
                          <option value="all">All</option>
                          <option value="Active">Active</option>
                          <option value="Inactive">Inactive</option>
                        </select>
                      </div>

                    </div>

                    {loading ? (
                      <Loader />
                    ) : (


                      <Table
                        columns={columns}
                        data={data}
                        page={page}
                        totalPages={totalPages}
                        initialRowsPerPage={rowsPerPage}
                        onPageChange={handlePageChange}
                        onRowsPerPageChange={handleRowsPerPageChange}
                      />
                    )}
                  </div>

                  {/* <div
                    className="d-flex justify-content-between align-items-center px-3 py-2"
                    style={{ marginBottom: "10px" }}
                  >

                    <div className="d-flex align-items-center mt-3">
                      <span>Rows per page:</span>
                      <select
                        className="form-select ms-2"
                        value={rowsPerPage}
                        onChange={(e) => setRowsPerPage(Number(e.target.value))}
                        style={{ width: "auto" }}
                      >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                    </div>

                    <div className="d-flex align-items-center gap-2">
                      <button
                        className="btn btn-outline-primary btn-sm d-flex align-items-center gap-1"
                        onClick={() => handlePageChange(page - 1)}
                        disabled={page === 1}
                      >
                        <i className="bi bi-chevron-left"></i>
                        <span>Prev</span>
                      </button>

                      <span className="fw-semibold text-secondary small">
                        Page {page} of {totalCount}
                      </span>

                      <button
                        className="btn btn-outline-primary btn-sm d-flex align-items-center gap-1"
                        onClick={() => handlePageChange(page + 1)}
                        disabled={page >= totalCount}
                      >
                        <span>Next</span>
                        <i className="bi bi-chevron-right"></i>
                      </button>
                    </div>
                  </div> */}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {modal && (
        <div
          className="modal custom-modal d-block"
          id="add_vendor"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered modal-md">
            <div className="modal-content">
              <div className="modal-header border-0 pb-0">
                <div className="form-header modal-header-title text-start mb-0">
                  <h4 className="mb-0">
                    {" "}
                    {type == "CREDIT" ? "Credit Fund" : "Debit Fund"}
                  </h4>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setModal(false);
                    setReason("");
                    setCustomReason("");
                    setBalance("");
                  }}
                ></button>
              </div>
              <div>
                <div className="modal-body">
                  <div className="row">
                    {/* Fund Input */}
                    <div className="col-lg-12 col-sm-12">
                      <div className="input-block mb-3">
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Enter Fund"
                          onChange={(e) => {
                            let value = e.target.value;
                            if (marketType === "USD" && Number(value) > 10000) {
                              value = "10000";
                            }
                            setBalance(value);
                          }}
                          value={balance}
                        />
                      </div>
                    </div>

                    {/* Reason Dropdown */}
                    <div className="col-lg-12 col-sm-12">
                      <div className="input-block mb-3">
                        <select
                          className="form-select"
                          value={reason}
                          onChange={(e) => setReason(e.target.value)}
                        >
                          <option value="">Select Reason</option>
                          <option value="Profit Share">Profit Share</option>
                          <option value="Referral Bonus">Referral Bonus</option>
                          {type == "CREDIT" && (
                            <option value="Manual Credit">Manual Credit</option>
                          )}
                          {type !== "CREDIT" && (
                            <option value="Manual Debit">Manual Debit</option>
                          )}
                          <option value="Demo">Demo</option>

                          <option value="Other">Other</option>
                        </select>
                      </div>
                    </div>

                    {/* Show custom input if "Other" is selected */}
                    {reason === "Other" && (
                      <div className="col-lg-12 col-sm-12">
                        <div className="input-block mb-3">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Custom Reason"
                            value={customReason}
                            onChange={(e) => setCustomReason(e.target.value)}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    data-bs-dismiss="modal"
                    className="btn btn-back cancel-btn me-2"
                    onClick={() => {
                      setModal(false);
                      setReason("");
                      setCustomReason("");
                      setBalance("");
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    data-bs-dismiss="modal"
                    className="btn btn-primary paid-continue-btn"
                    onClick={updateBalance}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}



      {/* {documentModal && (
        <div
          className="modal custom-modal d-block"
          id="document_modal"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered modal-md">
            <div className="modal-content">
              <div className="modal-header border-0 pb-0">
                <div className="form-header modal-header-title text-start mb-0">
                  <h4 className="mb-0"> User Documents</h4>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setDocumentModal(false);
                    setDocumentData([]);
                  }}
                ></button>
              </div>
              <div>
                <div className="modal-body">
                  <div className="row">
                   
                    <div className="col-lg-12 col-sm-12">
                      <div className="input-block mb-3">
                        {documentData && documentData.length > 0 ? (
                          documentData.map((doc) => (
                            <div key={doc._id} className="mb-3">
                              <h5>{doc.title}</h5>
                              <img
                                src={doc.image}
                                alt={doc.title}
                                style={{ maxWidth: "100%", height: "auto" }}
                              />
                            </div>
                          ))
                        ) : (
                          <p>No documents found.</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )} */}
      {documentModal && (
        <div
          className="modal show d-block"
          style={{
            background: "rgba(0,0,0,0.4)",
            backdropFilter: "blur(5px)", // 🔥 Blur effect
            zIndex: 1050,
          }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            {/* 🔥 modal-md ki jagah modal-lg = bigger modal */}
            <div className="modal-content shadow-lg border-0"
              style={{
                borderRadius: "12px",
              }}
            >

              {/* HEADER */}
              <div className="modal-header border-0 pb-0"
                style={{
                  borderLeft: "5px solid #4F46E5",   // 🔥 left side line
                  paddingLeft: "15px",
                }}
              >
                <h4 className="mb-0 fw-bold">User Documents</h4>

                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setDocumentModal(false);
                    setDocumentData([]);
                  }}
                ></button>
              </div>

              {/* BODY */}
              {/* BODY */}
<div className="modal-body" style={{ padding: "22px" }}>
  <div className="container-fluid">

    {documentData && documentData.length > 0 ? (
      documentData.map((doc) => (
        <div
          key={doc._id}
          className="p-3 mb-4"
          style={{
            background: "#f9fafb",
            borderRadius: "12px",
            border: "1px solid #e5e7eb",
          }}
        >
          {/* Title + Date */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="fw-semibold m-0">{doc.title}</h5>

            <span
              style={{
                fontSize: "12px",
                background: "#eef2ff",
                color: "#4F46E5",
                padding: "5px 10px",
                borderRadius: "20px",
                fontWeight: "500",
              }}
            >
              {new Date(doc.createdAt).toLocaleDateString()}
            </span>
          </div>

          {/* Images grid */}
          <div className="row g-3">

            {/* IMAGE 1 */}
            {doc.image && (
              <div className="col-md-6 col-12">
                <div className="doc-img-box">
                  <img src={doc.image} alt="doc1" />
                </div>
              </div>
            )}

            {/* IMAGE 2 */}
            {doc.image2 && (
              <div className="col-md-6 col-12">
                <div className="doc-img-box">
                  <img src={doc.image2} alt="doc2" />
                </div>
              </div>
            )}

          </div>
        </div>
      ))
    ) : (
      <div className="text-center py-5">
        <h6 className="text-muted">No documents found</h6>
      </div>
    )}
  </div>
</div>


            </div>
          </div>
        </div>
      )}




    </>
  );
};

export default Users;
